import { Injectable } from '@angular/core';
declare var acsbJS;

@Injectable({
  providedIn: 'root',
})
export class AccessibilityService {
  constructor() {}

  init(): void {
    acsbJS?.init({
      statementLink: '',
      footerHtml: '',
      hideMobile: false,
      hideTrigger: true,
      disableBgProcess: false,
      language: 'en',
      position: 'left',
      leadColor: '#000000',
    });
  }

  destroy() {
    acsbJS?.destroy();
  }
}
